import { render, staticRenderFns } from "./PayQuota.vue?vue&type=template&id=104f50fc&"
import script from "./PayQuota.vue?vue&type=script&lang=js&"
export * from "./PayQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports